<template>
	<div class="mt-2">
		<delete-dialog
            ref="deleteDialog"
            success-message='Data is deleted'
            @on-delete="needToResetShownRows = true; updateJournal()"
        >
			{{$t('JournalDeliveryOfSamples.are-you-sure-you-want-to-delete-this-transfer')}}
        </delete-dialog>
		<v-row>
			<v-col class="pb-0">
                <h1 class="text-h6 primary--text text-capitalize">
                    {{$t('routes.journal-delivery-of-samples')}}
                </h1>
            </v-col>

			<v-col
				cols="12"
				sm="auto"
				align-self="center"
				class="text-end"
			>
				<v-btn
					v-if="isSuperAdmin || permissionsUser.GenerateMaterials !== roleName.nothing"
					small
					:to="{ 
						name: 'supervisor-remaining-samples',
						query: { from: 'delivery' }
					}"
					color="dark-yellow white--text"
				>
					{{$t('JournalDeliveryOfSamples.remaining-materials')}}
				</v-btn>
			</v-col>
		</v-row>
		<!-- dialog -->
		<v-dialog width="400" v-model="dialog">
			<v-card>
				<div class="d-flex primary py-1">
					<v-card-title
						class="text-uppercase flex-grow-1 text-subtitle-1 justify-center pa-0 white--text"
					>
						{{ $t('edit') }}
					</v-card-title>

					<!-- close button -->
					<v-btn icon @click="dialog = false; $refs.form.resetValidation()">
						<v-icon color="white">
							mdi-close-circle-outline
						</v-icon>
					</v-btn>
				</div>

				<v-card-text class="mt-4">
					<v-row>
						<v-col cols="12" sm="6" class="py-1">
							<v-autocomplete
								v-model="sampleData.accountId"
								:items="allAccountsBrief.filter(c => c.id !== employeeId)"
								item-value="accountId"
								item-text="name"
								:disabled="submitLoading"
								:label="$t('inputs.account')"
								outlined
								dense
								hide-details
							></v-autocomplete>
						</v-col>

						<v-col cols="12" sm="6" class="py-1">
							<v-autocomplete
								v-model="sampleData.materialsAmount.materialId"
								:items="myMaterials"
								item-value="id"
								:item-text="(item) => `${item.remaining} - ${item.name}`"
								:label="$t('inputs.item')"
								outlined
								dense
								hide-details
								:disabled="submitLoading"
							></v-autocomplete>
						</v-col>

						<v-col cols="12" sm="6" class="py-1">
							<v-text-field
								v-model.number="sampleData.materialsAmount.amount"
								:label="$t('inputs.amount')"
								outlined
								dense
								hide-details
								:disabled="submitLoading"
							/>
						</v-col>

						<v-col cols="12" sm="6" class="py-1">
							<v-text-field
								v-model.number="sampleData.materialsAmount.sellPrice"
								:label="$t('inputs.price')"
								outlined
								dense
								hide-details
								:disabled="submitLoading || this.entityTab === 0"
							/>
						</v-col>

						<v-col>
                            <bee-date-input
                                v-model="sampleData.date"
                                :label="$t('inputs.date')"
                                input-format-order="DD-MM-YYYY"
                                dense
                                :loading="loading"
                                hide-details
                            ></bee-date-input>
                        </v-col>

						<v-col cols="12" sm="12" class="py-1">
							<v-text-field
								v-model="sampleData.description"
								:label="$t('inputs.notes')"
								outlined
								dense
								hide-details
								:disabled="submitLoading"
							/>
						</v-col>
					</v-row>
				</v-card-text>

				<v-card-actions>
					<v-btn color="success" small @click="editItem()" :loading="submitLoading">
						{{$t('save')}}
					</v-btn>

					<v-btn color="alert-color white--text" small @click="dialog = false" :disabled="submitLoading">
						{{$t('cancel')}}
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-row dense align="center" class="mt-1">
			<!-- filter -->
			<v-col cols="12" sm="6" md="2" class="d-flex">
				<v-btn 
					icon 
					@click="needToResetShownRows = true; prevJournal()"
				>
					<v-icon>
						{{ $i18n.locale === 'en' ? 'mdi-menu-left' : 'mdi-menu-right'}}
					</v-icon>
				</v-btn>
			
				<v-combobox
					v-model.number="journalNo"
					:items="journalNoList"
					label="رقم السند"
					type=number
					dense
					:loading="loading"
					append-icon=""
					readonly
					hide-details
				/>
				
				<v-btn 
					icon   
					@click="needToResetShownRows = true; nextJournal()"
				>
					<v-icon>
						{{$i18n.locale === 'en' ? 'mdi-menu-right' : 'mdi-menu-left'}}
					</v-icon>
				</v-btn>
			</v-col>
			<v-divider vertical class="mx-1" />
			<v-col cols="12" sm="6" md="3" class="" align-self="end">
				<bee-date-input
					v-model="date"
					:append-icon="$i18n.locale === 'en' ? 'mdi-menu-right' : 'mdi-menu-left'"
					:prepend-icon="$i18n.locale === 'en' ? 'mdi-menu-left' : 'mdi-menu-right'"
					:label="$t('inputs.date')"
					input-format-order="DD-MM-YYYY"
					dense
					:loading="loading"
					@click:append="
                        needToResetShownRows = true;
                        date = $i18n.locale === 'ar' ? moment(date).add(1, 'day').format('YYYY-MM-DD') : moment(date).subtract(1, 'day').format('YYYY-MM-DD');
                        getJournal(null, null,$route.query.tab);
                    "
					@click:prepend="
                        needToResetShownRows = true;
                        date = $i18n.locale === 'ar' ? moment(date).subtract(1, 'day').format('YYYY-MM-DD') : moment(date).add(1, 'day').format('YYYY-MM-DD');
                        getJournal(null, null,$route.query.tab);
                    "
					hide-details
				></bee-date-input>
			</v-col>

			<v-col cols="auto" align-self="end">
				<v-text-field 
					v-model="patientName"
					dense
					outlined
					hide-details
					:label="$t('inputs.patient-name')"
				/>
				
			</v-col>
			<!-- {{entity}} -->
			<!-- <v-col v-if="entityTab === 1" md="2">
				<v-autocomplete 
					v-model.number="entity"
					:items="entityTypeArray"
					item-text="name"
					item-value="id"
					:label="$t('inputs.type')"
					outlined
					dense
					hide-details
					:disabled="loading || submitLoading"
					:loading="loading || submitLoading"
				/>
			</v-col> -->

			<v-col cols="auto" class="pt-0 pb-1" align-self="center">
				<v-btn
					@click="search()"
					color="success white--text"
					small
					:disabled="loading"
					:loading="loading || submitLoading"
				>
					{{$t('search')}} 
				</v-btn>
			</v-col>

			<v-col cols="auto" class="pt-0 pb-1" align-self="center">
				<v-btn
					@click="resetFilter(); getListJournalNo()"
					color="alert-color white--text"
					small
					:disabled="loading"
					:loading="loading || submitLoading"
				>
					{{$t('cancel')}} 
				</v-btn>
			</v-col>
		</v-row>
	      
		<v-tabs
			v-model="entityTab"
			height="40"
			@change="changeTab()"
		>
			<v-tab
				v-for="item in types"
				:key="item.id"
				:disabled="loading"
			>
				{{item.name}}
			</v-tab>
		</v-tabs>

		<v-divider class="mb-2" />
		<div class="d-flex justify-space-between">
			<!-- deliver / receive tabs -->
			<v-tabs
				v-model="tab"
				height="30"
				active-class="secondary lighten-1 white--text overflow-hidden rounded-t"
				@change="changeTab()"
			>
				<v-tab :disabled="loading">{{$t('JournalDeliveryOfSamples.deliver')}}</v-tab>
				<v-tab :disabled="loading">{{$t('JournalDeliveryOfSamples.receive')}}</v-tab>
				<v-tabs-slider color="secondary lighten-3"></v-tabs-slider>
			</v-tabs>
			<v-divider class="my-2" />
	
			<v-btn small color="success" @click="createNewJournal()">
				إنشاء يومية جديدة 
			</v-btn>
		
		</div>
		<!-- table -->
     	<bee-handy-smart-table
			v-model="tableInputs"
			ref="table"
			:headers="headers"
			:items="[]"
			:show-add-row="(permissionsUser.MaterialTransactions !== roleName.read )|| (isSuperAdmin)"
			:loading="loading"
			:items-per-page="50"
			hide-default-footer 
			dense
			zebra
			:disable-input-fields="loading"
            fixed-header
			:height="$vuetify.breakpoint.height - 210"
            :options-scroll.sync="scrollOptions"
            pagination-on-scroll
            pagination-on-scroll-server-items
            :server-items-length="serverItemsLength"
            @pagination-on-scroll:reach-last-row="getJournal"
			:pagination-on-scroll-auto-reset-shown="false"
			@keypress.enter="addItem()"
			@sheet-add-clicked="addItem"
			@dblclick:row="goToStatement"
			@change-accountId="getMaterialByAccount()"
		>
			<!-- <template v-slot:item.accountId="{ item }">
				{{getAccount(item)}}
			</template> -->

			<template v-slot:item.state="{ item }">
				{{ item.sellPrice !== null ? 'مباع' : 'قابل للإعادة' }}
			</template>

			<!-- <template v-slot:input.fromVisit="{ on, attr }">
				<v-checkbox 
					v-model="tableInputs.fromVisit"
					class="mt-0" 
					hide-details 	
					v-on="on"
					v-bind="attr" 
				/>
			</template> -->
			
            <!-- accounts
			<template v-slot:input.accountId="{ on, attr }">
				<v-autocomplete
					:items="allAccountsBrief.filter(c => c.id !== employeeId)"
					item-value="accountId"
					item-text="name"
					v-on="on"
					v-bind="attr"
					:disabled="loading"
				></v-autocomplete>
			</template> -->
			<!-- accounts -->
			<!-- :item-value="entityTab !== 1 ? 'accountId' : 'name'" -->
			<template v-slot:input.accountId="{ on, attr }">
				<v-autocomplete
					:items="allAccountsBrief.filter(c => c.id !== employeeId)"
					item-text="name"
					item-value='accountId'
					v-on="on"
					v-bind="attr"
					:readonly="materialLoading || isReadOnly"
				></v-autocomplete>
			</template>

			<!-- product name -->
			<template v-slot:input.materialId="{ on, attr }">
				<v-autocomplete
					:items="myMaterials"
					item-value="id"
					:item-text="(item) => `${item.remaining} - ${item.name}`"
					v-on="on"
					v-bind="attr"
				></v-autocomplete>
			</template>

			<template v-slot:item.actions="{ item }">
				<v-btn
					color="success"
					small
					icon
					@click="dialog = true; myItem = item; isEdit = true"
				>
					<v-icon>mdi-pencil</v-icon>
				</v-btn>

				<v-btn
					color="alert-color"
					small
					icon
					@click="isDeleted = true; $refs.deleteDialog.activeDeleteDialog(item.id, 'materialTransactions')"
				>
					<v-icon> mdi-delete </v-icon>
				</v-btn>
            </template>
       	</bee-handy-smart-table>
		<!-- <v-row class="mt-3" style="width: 100%">
			<v-col>
				<v-btn>
					إغلاق يوم 
				</v-btn>
			</v-col>
		</v-row> -->

		<!-- <div
			v-if="!existType && entityTab === 1"
			class="d-flex flex-column justify-center align-center"
            :style="{ height: `${$vuetify.breakpoint.height - 300}px` }"
		>
			<template >
				<v-icon size="60" class="mb-1">mdi-invoice-list</v-icon>
				<span class="text-h6">{{$t('SamplesStatement.please-select-a-filter')}}</span>
			</template>
		</div> -->
	</div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import { roleName, entityTypeArray, entityType } from '@/helpers/enums'
import moment from 'moment'
import DeleteDialog from '@/components/DeleteDialog'
import rules from '@/validation rules'

export default {
	name: 'JournalDeliveryOfSamples',

	components: {
		DeleteDialog
	},

	watch: {
		dialog (val) {
			if (val) {
				this.sampleData.materialsAmount.materialId = this.myItem.materialId
				this.sampleData.accountId = this.myItem.accountId
				this.sampleData.materialsAmount.amount = this.myItem.in !== null ? this.myItem.in.amount : this.myItem.out.amount
				this.sampleData.description = this.myItem.description
				this.itemId = this.myItem.id
				this.sampleData.date = this.myItem.date
				this.sampleData.type = this.myItem.transactionType
				this.sampleData.materialsAmount.sellPrice = this.myItem.sellPrice
			} else {
				this.sampleData.materialsAmount.materialId = null
				this.sampleData.accountId = null
				this.sampleData.materialsAmount.amount = null
				this.sampleData.description = null
				this.itemId = null
				this.sampleData.date = null
				this.sampleData.type = null
				this.sampleData.materialsAmount.sellPrice = null
				this.isEdit = false
				this.isDeleted = false
			}
		},

		// entity(val) {
		// 	if (val === null) {
		// 		this.existType = false
		// 	}
		// },
		date(val) {
			if (val) {
				this.journalNo = null
			}
		}
	},
    data () {
        return {
			journalNo: null,
			isEdit: false,
			isDeleted: false,
			submitLoading: false,
			myItem: null,
			dialog: false,
			editId: null,
			isEditItem: false,
			tab: 0,
			entityTab: 0,
			roleName,
            loading: false,
            tableInputs: {
				// fromVisit: false
				// date: this.moment().format('YYYY-MM-DD')
			},
			rowEditIndex: null,
			date: null,
			serverItemsLength: 0,
			scrollOptions: {},
			types: [
                { id: 0, name: this.$t('tabs.staff') },
                { id: 1, name: this.$t('tabs.customers') },
                { id: 2, name: this.$t('tabs.external') }
            ],
			briefAccounts: [
                [], // for staff
                [], // for customers
                [], // for external
            ],

			itemId: null,
			sampleData:{
                materialsAmount:{
                    materialId: null,
                    amount: null,
					sellPrice: 0,
                },
                accountId: null,
                date: null,
                description: null,
                type: null
            },
			// entity: null,
			entityTypeArray,
			// existType: false,
			materialLoading: false,
			numbers: [3, 5, 6, 8, 9],
			isReadOnly: false,
			lastJournalNo: 1,
			patientName: null,
			currentUserData: null
        }
    },

    computed: {
        ...mapState({
            supervisors: state => state.supervisors.supervisors,
            // materials: state => state.materials.materials,
			myMaterials: state => state.materials.myMaterials,
			isSuperAdmin: state => state.auth.isSuperAdmin,
			permissionsUser: state => state.auth.youPermissions,
			employeeId: state => state.auth.userData.employeeId,
			journalNoList: state => state.materialTransactions.journalNoList
        }),

        ...mapGetters({
            // getMaterialById: 'materials/getMaterialById',
            getSupervisorById: 'supervisors/getSupervisorById',
			getAccountById: 'accounts/getAccountById'
        }),

        headers () {
            const headers = [
                {
                    text: this.$t('headers.account'),
                    name: 'accountId',
                    value: 'accountId',
                    setValueExpr: val => this.allAccountsBrief?.find(c => c.accountId === val)?.name,
                    type: 'string'
                },
                {
                    text: this.$t('headers.item'),
                    name: 'materialId',
                    value: 'materialId',
                    setValueExpr: val => this.myMaterials?.find(c => c.id === val)?.name,
                    type: 'string'
                },
                {
                    text: this.$t('headers.amount'),
                    name: 'amount',
                    value: 'amount',
					inputRules: rules.IntNumber,
                    type: 'number'
                },
				{
                    text: this.$t('headers.notes'),
                    name: 'description',
                    value: 'description',
                    type: 'string'
                },
				{
                    text: this.$t('headers.deliver-date'),
                    name: 'date',
                    value: 'date',
                    type: 'date',
                    width: "20%"
                },
				{
					text: '',
                    name: 'actions',
                    value: 'actions',
                    noInput: true,
                    noNotAvailableText: true,
                    sortable: false
				}
            ]
			if (this.tab === 0 && this.entityTab !== 0) {
				headers.splice(4, 0, 
					{
						
						text: this.$t('headers.sell-price'),
						name: 'sellPrice',
						value: 'sellPrice',
						type: 'number',
					},
					// {
					// 	text: 'من زيارة',
					// 	name: 'fromVisit',
					// 	value: 'fromVisit',
					// 	type: 'Boolean',
					// 	setValueExpr: val => val === true ? 'نعم ' : 'لا',
					// 	sortable: false
					// },
					{
						text: 'الحالة',
						name: 'state',
						value: 'state',
						type: 'string',
						noInput: true,
						sortable: false
					}
				)
			}
			return headers
        },

		allAccountsBrief() {
            return this.briefAccounts[this.entityTab];
        },
		
		// currentUserData() {
		// 	return this.briefAccounts[0].find(c => c.id === this.employeeId);
        // },
    },

    methods: {
		editItem() {
			this.submitLoading = true
			this.$store.dispatch('materialTransactions/update', {
				id: this.itemId,
				newSampleData: this.sampleData
			}).then(() => {
				this.dialog = false
				this.needToResetShownRows = true
				this.getJournal()
			}).finally(() => {
				this.submitLoading = false
			})
		},
		setRowIndex(rowData) {
			this.rowEditIndex = rowData.index;
			this.isEditItem = true;
			this.$nextTick(() => {
				// this.$refs.table.resetInputsFocus()
			})
		},
		goToStatement(item) {
			console.log('kp')
			if (this.isEdit === false && this.isDeleted === false) {
				this.$router.replace({
					name: 'samples-statement',
					query: {
						id: item.materialId
					}
				})
			}
        },
		
		getAllAccount(isFirstLoad) {
            if (this.allAccountsBrief.length && this.entityTab !== 1) return;

            this.loading = true;
            return this.$store.dispatch('accounts/fetchAllBrief', {
                type: this.entityTab,
				entityType: entityType.doctor
            }).then((data) => {
                this.briefAccounts[this.entityTab].push(...data);
            }).finally(() => {
                if (!isFirstLoad) this.loading = false;
            })
        },

		updateTableDueTab() {
            this.$refs.table.resetShownRows();
            // this.$refs.table.resetInputs({ date: this.moment().format('YYYY-MM-DD') });
			this.tableInputs.amount = null
			this.tableInputs.materialId = null
			this.tableInputs.note = null

            this.$router.replace({ name: 'journal-delivery-of-samples', query: { tab: this.entityTab } });
			// if (this.existType === false && this.entityTab !== 1) {
			this.updateJournal()
			// }
        },

		async updateJournal(isFirstLoad = false) {
            this.loading = true;
            return Promise.all([
                await this.getAllAccount(),
                this.getJournal(null, true),
            ]).finally(() => {
                if (!isFirstLoad) this.loading = false;
            });
        },

		moment,
		getAccount(item) {
			const accountName = this.allAccountsBrief.find(c => c.accountId === (
				this.entityTab === 0 && this.tab === 1
					? item.fromAccountId
					: item.accountId
				)
			)
			return accountName ? accountName.name : '-'
		},

        addItem () {
			if (this.$refs.table.validate()) {
				this.loading = true
				var materials = {
					materialsAmount: {
						materialId: this.tableInputs.materialId,
						amount: this.tableInputs.amount,
						sellPrice: this.tableInputs.sellPrice ? this.tableInputs.sellPrice : 0
					},
					fromAccountId: this.tab === 0 ? this.currentUserData : this.tableInputs.accountId,
					toAccountId: this.tab === 0 ? this.tableInputs.accountId : this.currentUserData,
					date: this.tableInputs.date,
					description: this.tableInputs.description,
					// fromVisit: this.tableInputs.fromVisit,
					journalNo: this.journalNo
				}

				this.$store.dispatch('materialTransactions/createDeliverAndReceive', { materials }).then(async() => {
					this.needToResetShownRows = true
					this.tableInputs.materialId = null
					this.tableInputs.amount = null
					this.tableInputs.accountId = this.tab === 0 ? materials.toAccountId : materials.fromAccountId
					// this.isReadOnly = true
					this.$store.dispatch('materialTransactions/fetchLastJournalNo').then((data) => { 
						this.lastJournalNo = data.data; 
					})
					await this.updateJournal()
				}).catch(() => {
					this.loading = false
				})
			}
        },

		getJournal(newOptionsScroll, isFirstLoad = false) {
            let page = 1
            const { itemsPerPage } = this.scrollOptions;
            if (newOptionsScroll) page = newOptionsScroll.page || 1;
            
            this.loading = true
			return this.$store.dispatch('materialTransactions/fetchStatement', {
                Date: this.date,
                Page: page,
                PerPage: itemsPerPage || 50,
                type: this.entityTab,
				SelectInAmount: this.tab === 0,
				SelectOutAmount: this.tab === 1,
				entity: entityType.doctor,
				journalNo: this.journalNo,
				patientName: this.patientName
            }).then(({ data, total }) => {
				if (data.length) {
					const items = data.map(c => ({ 
						...c, 
						amount: (c.in || c.out).amount,
						materialId: (c.in || c.out).materialId,
						accountId: c.accountId,
						notes: c.description,
					}));
	
					if (this.needToResetShownRows) {
						this.needToResetShownRows = false;
						this.$refs.table.resetShownRows();
					}
	
					this.serverItemsLength = total;
					this.$refs.table.addScrollItems(items);
					this.tableInputs.accountId = data[0].accountId
				} else {
					// this.prevJournal()
				}
			}).finally(() => {
                if (!isFirstLoad) this.loading = false;
            })
		},

		search() {
			// this.existType = true; 
			this.needToResetShownRows = true; 
			this.updateJournal()
		},

		resetFilter () {
			this.type = null
			this.entity = null
			this.date = null
			this.$refs.table.resetShownRows()
		},

		getMaterialByAccount () {
			let employeeId = null
			if (this.tab === 1 && this.entityTab === 0) {
				employeeId = this.allAccountsBrief.find(c => c.accountId === this.tableInputs.accountId)?.id
				this.materialLoading = true
				this.$store.dispatch('materials/fetchMyMaterial', { employeeId: employeeId }).finally(() => {
					this.materialLoading = false
				})
			}
		},
		nextJournal() {
			if (this.journalNoList.length && this.journalNoList.indexOf(this.journalNoList.find(c => c === this.journalNo)) !== this.journalNoList.length - 1) {
				this.journalNo = this.journalNoList[this.journalNoList.indexOf(this.journalNoList.find(c => c === this.journalNo)) + 1]
				this.getJournal()
			}
		},
		prevJournal() {
			if (this.journalNoList.length && this.journalNoList.indexOf(this.journalNoList.find(c => c === this.journalNo)) !== 0) {
				if (this.journalNoList.includes(this.journalNo)) {
                    this.journalNo = this.journalNoList[this.journalNoList.indexOf(this.journalNoList.find(c => c === this.journalNo)) - 1]
                } else {
                    this.journalNo = this.journalNoList[this.journalNoList.length - 1]
                }
				this.getJournal()
			}
		},
		
		// create journal by add 1 to the journal no 
		createNewJournal() {
			console.log(this.lastJournalNo)
			this.journalNo = Number(this.lastJournalNo) + 1
			this.$refs.table.resetInputs()
			this.$refs.table.resetShownRows()	
		},
		getListJournalNo(isFirst = false) {
			this.$refs.table.resetShownRows()
			return this.$store.dispatch('materialTransactions/fetchJournalNoArray', {
				isStaff: this.entityTab === 0,
				selectOutAmount: this.tab === 1,
				selectInAmount: this.tab === 0
			}).then((data) => {
				this.journalNo = data[data.length - 1]
			}).finally(() => {
				if (!isFirst) this.loading = false
			})
		},
		changeTab() {
			// this.existType = false
			// this.loading = true
			this.getListJournalNo().then(() => {
				this.resetFilter()
				this.updateTableDueTab()
			})
			// .finally(() => {
			// 	this.loading = false	
			// })
		}
		
    },

    mounted () {
        this.loading = true;
		this.needToResetShownRows = true;
		this.entityTab = +this.$route.query.tab || 0;

		Promise.all([
			this.getListJournalNo(true),
			this.$store.dispatch('materialTransactions/fetchLastJournalNo').then((data) => { 
				this.lastJournalNo = data.data; 
			}),

			this.$store.dispatch('materials/fetchMyMaterial', { 
				employeeId: this.allAccountsBrief.find(c => c.accountId === this.tableInputs.accountId)?.id 
			}).then((data) => {
				// console.log(this.myMaterials)
			}),
			this.$store.dispatch('accounts/fetchAllBrief', {
                type: 0,
            }).then((data) => {
				this.currentUserData = data.find(c => c.id === this.employeeId)?.accountId 
			}),
			this.updateJournal(true),
        ]).finally(() => {
			// console.log(this.currentUserData)
			// console.log(this.briefAccounts[0])
            this.loading = false
        })
    }
}
</script>
<style scoped>
</style>
